import { MDM_PROPERTIES, MDM_TYPES, MdmPropertyValue } from '@/constants/mdm';

import type { ObjectFieldType } from './types';

const ACCOUNT_PRODUCT_PROPERTIES = MDM_PROPERTIES[MDM_TYPES.ACCOUNT_PRODUCT];

export type MappingRowConfig = {
  label: string;
  mdmProperty: MdmPropertyValue<typeof MDM_TYPES.ACCOUNT_PRODUCT>;
  testId: string;
  required: boolean;
  allowedTypes?: ObjectFieldType[];
  noOptionsMessage?: string;
};

export const ACCOUNT_PRODUCT_ROWS: MappingRowConfig[] = [
  {
    label: 'Account ID',
    mdmProperty: ACCOUNT_PRODUCT_PROPERTIES.COMPANY_ID,
    testId: 'product-mapping-row-company-id',
    required: true,
    allowedTypes: ['reference'],
    noOptionsMessage:
      'This object has no Account lookup Crossbeam can use. Pick another object.',
  },
  {
    label: 'Product Name',
    mdmProperty: ACCOUNT_PRODUCT_PROPERTIES.NAME,
    testId: 'product-mapping-row-name',
    required: true,
  },
  {
    label: 'Status',
    mdmProperty: ACCOUNT_PRODUCT_PROPERTIES.STATUS,
    testId: 'product-mapping-row-status',
    required: false,
  },
];

export const ACCOUNT_PRODUCT_SECTIONS = [
  {
    title: 'Required fields',
    rows: ACCOUNT_PRODUCT_ROWS.filter((row) => row.required),
  },
  {
    title: 'Optional',
    rows: ACCOUNT_PRODUCT_ROWS.filter((row) => !row.required),
  },
];
